import type { SVGProps } from "react";
export default function ReshopLogoSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={27}
      fill="none"
      viewBox="0 0 24 27"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <path
        fill="#FF5734"
        d="M.111.602C.111.269.376 0 .703 0h12.416c2.885 0 5.72 1.209 7.773 3.315 2.024 2.078 3.13 4.794 3.108 7.652 0 .14 0 .276-.01.416-.091 2.099-.812 4.11-2.04 5.804-.818 1.125-1.866 2.057-3.037 2.794l-2.308 1.453c-.158.1-.089.348.096.348h5.929c.327 0 .591.269.591.602v3.303a.596.596 0 0 1-.591.602h-9.948c-1.762 0-3.19-1.454-3.19-3.247v-9.626c0-.333.264-.602.591-.602h3.26c.327 0 .591.27.591.602v4.864c0 .17.2.252.315.132l2.998-3.06a6.33 6.33 0 0 0 1.82-4.466c0-3.482-2.784-6.313-6.207-6.313H5.677a.596.596 0 0 0-.592.602v20.512a.596.596 0 0 1-.591.602H.693a.596.596 0 0 1-.591-.602z"
      />
    </svg>
  );
}
